/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Input } from "@angular/core";
import { ImageUploadService } from "../../../services/productFeatureServices/image-upload.service";
import { ReviewService } from "../../../services/productFeatureServices/review.service";
import { CheckImageUrlService } from "src/app/check-image-url.service";

@Component({
  selector: "app-user-profile-pic",
  templateUrl: "./user-profile-pic.component.html",
  styleUrls: ["./user-profile-pic.component.scss"],
})
export class UserProfilePicComponent implements OnInit {
  @Input() profile: string;
  // profile:string;
  errorMessage = "";
  uploadImages: any;
  displayImages = [];
  constructor(
    private imageUploadService: ImageUploadService,
    private imgCheck: CheckImageUrlService,
    private ratingService: ReviewService
  ) {}

  ngOnInit() {
    this.ratingService.uploadProfileImageSubject.subscribe(
      (res) => {
        const path = this.imgCheck.verifyImage(res.imageURI);
        console.log("path:" + path);
        this.profile = path;
        localStorage.setItem("userPic", this.profile);
        this.imageUploadService.uploadProfileUrl(res).subscribe(
          (data) => {
            console.log(data);
          },
          (err) => {
            this.profile = err;
          }
        );
      },
      (err) => console.log(err)
    );
  }
  onFileSelected(event) {
    this.uploadImages = event.target.files[0];
    this.imageUploadService.uploadProfileImage(this.uploadImages);
  }
}
